import React from 'react';

// Context
export const CONTRACTS = '[Contracts]';

// Commands
export const FETCH_ALL_CONTRACTS = `${CONTRACTS} FETCH_ALL_CONTRACTS`;
export const FETCH_COMPANY_CONTRACTS = `${CONTRACTS} FETCH_COMPANY_CONTRACTS`;
export const FETCH_CUSTOMER_CONTRACTS = `${CONTRACTS} FETCH_CUSTOMER_CONTRACTS`;
export const FETCH_CONTRACT = `${CONTRACTS} FETCH_CONTRACT`;
export const UPDATE_CONTRACT = `${CONTRACTS} UPDATE_CONTRACT`;
export const UPDATE_CONTRACT_STATUS = `${CONTRACTS} UPDATE_CONTRACT_STATUS`;
export const SIGN_CONTRACTS = `${CONTRACTS} SIGN_CONTRACT`;
export const UPDATE_UPDATE_SCHEDULE = `${CONTRACTS} UPDATE_UPDATE_SCHEDULE`;
export const UPLOAD_DELIVERY_SLIP = `${CONTRACTS} UPLOAD_DELIVERY_SLIP`;

// Document
export const SET_CONTRACTS = `${CONTRACTS} SET`;
export const INSERT_CONTRACT = `${CONTRACTS} INSERT`;
export const PUT_CONTRACT = `${CONTRACTS} PATCH`;
export const PUT_OR_INSERT = `${CONTRACTS} PATCH/INSERT`;

// Events
export const CONTRACT_APPROVED = `${CONTRACTS} CONTRACT_APPROVED`;
export const CONTRACTS_APPROVED = `${CONTRACTS} CONTRACTS_APPROVED`;
export const DELIVERY_SLIP_UPLOADED = `${CONTRACTS} DELIVERY_SLIP_UPLOADED`;
export const DELIVERY_SLIP_SIGNED = `${CONTRACTS} DELIVERY_SLIP_SIGNED_UPLOADED`;
export const SIGN_DELIVERY_SLIP_UPLOADED = `${CONTRACTS} SIGN_DELIVERY_SLIP_UPLOADED`;
export const DELIVERY_CONFIRMED = `${CONTRACTS} DELIVERY_CONFIRMED`;
export const PAYMENT_ISSUED = `${CONTRACTS} PAYMENT_ISSUED`;
export const PAYMENT_CONFIRMED = `${CONTRACTS} PAYMENT_CONFIRMED`;
export const AGREEMENT_SIGNED = `${CONTRACTS} AGREEMENT_SIGNED`;


/*
 * Signing contract process.
 */
export const signContracts = (contracts, signatureRef) => ({
    type: SIGN_CONTRACTS,
    payload: {
        data: contracts,
        meta: {signatureRef}
    }
});

export const getAllContracts = () => ({
    type: FETCH_ALL_CONTRACTS,
    payload: {}
});

export const getCompanyContracts = companyId => ({
    type: FETCH_COMPANY_CONTRACTS,
    payload: {companyId}
});

export const getCustomerContracts = (companyId, customerId) => ({
    type: FETCH_CUSTOMER_CONTRACTS,
    payload: {
        companyId,
        customerId
    }
});

export const getContract = (companyId, customerId, repId, contractId) => ({
    type: FETCH_CONTRACT,
    payload: {
        companyId,
        customerId,
        repId,
        contractId
    }
});

export const updateContract = (companyId, customerId, repId, contractId, contractForUpdate, eventAction = null) => ({
    type: UPDATE_CONTRACT,
    payload: {
        data: contractForUpdate,
        meta: {
            companyId,
            customerId,
            repId,
            contractId,
            eventAction
        },
    }
});

export const setContracts = contracts => ({
    type: SET_CONTRACTS,
    payload: {data: contracts}
});

export const insertContract = contract => ({
    type: INSERT_CONTRACT,
    payload: {data: contract}
});

export const putContract = contract => ({
    type: PUT_CONTRACT,
    payload: {data: contract}
});

export const putOrInsertContract = contract => ({
    type: PUT_OR_INSERT,
    payload: {data: contract}
});

export const updateContractSchedule = (contract, schedule) => ({
    type: UPDATE_UPDATE_SCHEDULE,
    payload: {
        data: {
            contract,
            schedule
        }
    }
});

// Events
export const deliverySlipUploadedEvent = contract => ({
    type: DELIVERY_SLIP_UPLOADED,
    payload: {data: contract}
});

export const contractApprovedEvent = contract => ({
    type: CONTRACT_APPROVED,
    payload: {data: contract}
});

export const contractsApproved = contracts => ({
    type: CONTRACT_APPROVED,
    payload: {data: contracts}
});

export const signedDeliverySlipUploadedEvent = contract => ({
    type: SIGN_DELIVERY_SLIP_UPLOADED,
    payload: {data: contract}
});

export const deliverySlipSignedEvent = contract => ({
    type: DELIVERY_SLIP_SIGNED,
    payload: {data: contract}

});

export const devicesDeliveredEvent = contract => ({
    type: DELIVERY_CONFIRMED,
    payload: {data: contract}
});

export const paymentIssuedEvent = contract => ({
    type: PAYMENT_ISSUED,
    payload: {data: contract}
});

export const paymentConfirmedEvent = contract => ({
    type: PAYMENT_CONFIRMED,
    payload: {data: contract}
});

export const agreementSignedEvent = contract => ({
    type: AGREEMENT_SIGNED,
    payload: {data: contract}
});
